module.exports = __webpack_public_path__ + "assets/6557a56b2471402bb51914adf4d08082.png";